import { NetworkDataType } from '@/common/models/NetworkDataTransfers';
import { useControllerAppModel } from '@/controller/models/ControllerAppModel';
import { ClassNames } from '@emotion/react';
import {
  Button,
  Dialog,
  flex1,
  FlexColumn,
  FlexRow,
  fullSize,
  fullWidth,
  IconButton,
  Intent,
  relative,
} from '@toilet-paper-games/ui';
import { QrCode, Settings, UsersRound } from 'lucide-react';
import { action } from 'mobx';
import { observer } from 'mobx-react-lite';
import { DisplayName } from '../DisplayName';
import { FeedbackButton } from '@/common/components/FeedbackButton';
import { DonateButton } from '@/common/components/DonateButton';

export interface MenuDialogProps {}

// Component for the Players button
const PlayersButton = observer(() => {
  const appStore = useControllerAppModel();

  return (
    <IconButton
      shadow
      icon={<UsersRound />}
      onClick={action(() => {
        appStore.uiModel.showPlayersDialog = true;
      })}
    >
      Players
    </IconButton>
  );
});

const SettingsButton = observer(() => {
  const appStore = useControllerAppModel();

  return (
    <IconButton
      shadow
      icon={<Settings />}
      onClick={action(() => {
        appStore.uiModel.showSettingsDialog = true;
      })}
    >
      Settings
    </IconButton>
  );
});

// Component for the Restart and End buttons
const GameControlButtons = observer(() => {
  const appStore = useControllerAppModel();

  return (
    <FlexRow gap={10}>
      <Button
        shadow
        css={[flex1]}
        intent={Intent.Danger}
        disabled={!appStore.isPlayingGame || !appStore.user?.isHost}
        onClick={() => {
          const hostConnection = appStore.networkHandler.hostConnection;

          hostConnection?.send({
            type: NetworkDataType.REFRESH,
            data: {},
          });

          appStore.uiModel.showMenuDialog = false;
        }}
      >
        Restart
      </Button>
      <Button
        shadow
        css={[flex1]}
        intent={Intent.Danger}
        disabled={!appStore.isPlayingGame || !appStore.user?.isHost}
        onClick={() => {
          const hostConnection = appStore.networkHandler.hostConnection;

          hostConnection?.send({
            type: NetworkDataType.END_GAME,
            data: {},
          });

          appStore.uiModel.showMenuDialog = false;
        }}
      >
        End
      </Button>
    </FlexRow>
  );
});

// Main MenuDialog component
export const MenuDialog = observer((props: MenuDialogProps) => {
  const appStore = useControllerAppModel();

  const isOpen = appStore.uiModel.showMenuDialog;
  const user = appStore.user;
  const isPlayingGame = appStore.isPlayingGame;

  return (
    <ClassNames>
      {({ css }) => (
        <Dialog
          open={isOpen}
          title="Menu"
          onOpenChange={action((open) => (appStore.uiModel.showMenuDialog = open))}
          cardProps={{
            className: css([
              {
                width: 'min(calc(100vw - 20px), 250px)',
              },
              relative(),
            ]),
          }}
        >
          <FlexColumn css={[fullSize]} gap={30}>
            <DisplayName css={[fullWidth]} user={user} allowNameChange={!isPlayingGame} />
            {/* //TODO Add Profile Button once Profile Page is completed */}
            {/* <ProfileButton /> */}
            <PlayersButton />
            <SettingsButton />
            <FeedbackButton />
            <DonateButton />
            <GameControlButtons />
            {/* // TODO: Add hold to show Join code overlay */}
            {/* {appStore.isPlayingGame && (
          <IconButton css={[{ marginTop: 20 }]} icon={<QrCode />} intent={Intent.Success}>
          <div>Hold to show</div>
          <div>Join Code</div>
          </IconButton>
          )} */}
          </FlexColumn>
        </Dialog>
      )}
    </ClassNames>
  );
});
